import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { Container, Section } from '../ui/Section';
import { NewTabHint } from '../ui/NewTabHint';
import { Reveal, stagger } from '../motion/Reveal';
import { DoodleStar } from '../brand/Doodles';
import { officialChannels } from '../../data/site';

/**
 * Compact panel pointing students to the three official channels where the
 * current schedule actually lives. Reused on the homepage and Events page.
 */
export function ScheduleChannels({
  headingId = 'schedule-channels-heading'
}: {
  headingId?: string;
}) {
  return <Section className="relative overflow-hidden bg-brand-blue py-12 sm:py-16" labelledBy={headingId} data-id="element-396" data-mp="2740k7n6xzcn3">
      <DoodleStar className="pointer-events-none absolute right-6 top-6 h-9 w-9 sm:h-12 sm:w-12" color="var(--bcm-yellow)" data-id="element-397" data-mp="1y56u8fo49kii" />
      <Container data-id="element-398" data-mp="hpvl2pd23uwr">
        <Reveal data-id="element-399" data-mp="htj9xb7k3t55">
          <h2 id={headingId} className="font-display text-2xl font-extrabold leading-tight tracking-tight text-brand-navy sm:text-4xl" data-id="element-400" data-mp="mqjfzm4eovw9">
            Get the latest BCM schedule
          </h2>
          <p className="mt-3 max-w-2xl font-sans text-[16px] leading-relaxed text-ink" data-id="element-401" data-mp="2liq5xmf2f0xw">
            Special events, room changes, and weekly reminders are shared through BCM’s official
            student channels.
          </p>
        </Reveal>

        <ul className="mt-8 grid gap-4 sm:grid-cols-3" data-id="element-402" data-mp="2vi783tv3ywp4">
          {officialChannels.map((channel, index) => <Reveal key={channel.id} as="li" delay={stagger(index)} className="h-full" data-id="element-403" data-mp="39dj382d6ep6k" data-mpi={index}>
              <a href={channel.href} target="_blank" rel="noopener noreferrer" className="flex h-full flex-col rounded-[20px] border-2 border-brand-navy bg-white p-5 transition-transform duration-200 hover:-translate-y-1" data-id="element-404" data-mp="34epz30js4aj2">
                <span className="flex items-center justify-between gap-2 font-display text-lg font-bold text-brand-navy" data-id="element-405" data-mp="3s40sfwysv2n6">
                  {channel.title}
                  <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4 shrink-0" data-id="element-406" data-mp="3v91b3xnjg3k4" />
                </span>
                <span className="mt-2 font-sans text-[14.5px] leading-relaxed text-ink" data-id="element-407" data-mp="42gn6mss5brb">
                  {channel.copy}
                </span>
                <NewTabHint data-id="element-408" data-mp="drhza1w7f900" />
              </a>
            </Reveal>)}
        </ul>
      </Container>
    </Section>;
}